const firebaseConfig = {
  apiKey: "AIzaSyAB_aGpAbqGJHkUNElePuFQhZ8ogXRz6co",
  authDomain: "phoenixstudiosite.firebaseapp.com",
  databaseURL: "https://phoenixstudiosite.firebaseio.com",
  projectId: "phoenixstudiosite",
  storageBucket: "phoenixstudiosite.appspot.com",
  messagingSenderId: "880873922366",
  appId: "1:880873922366:web:afb66cb212e40076d5d66f"
};
export default firebaseConfig;

